module.exports = __webpack_public_path__ + "media/images/company_logo/logo_tg-0056bb86cb0125694c1fb927de6db429.jpg";